import { Swiper } from "swiper/swiper-react";
import { Box, IconButton } from "@mui/material";
import { styled } from "@mui/system";
import { BOX_SHADOWS } from "@shared/styles";

export const GroupsSwiper = styled(Swiper)({
    overflow: "visible",
    "@media (min-width: 640px)": {
        overflow: "hidden",
    },
    ".swiper-button-disabled": {
        color: "transparent",
    },
    ".swiper-button-prev:after": {
        content: "none",
    },
    ".swiper-button-next:after": {
        content: "none",
    },
    "& .swiper-pagination.swiper-pagination": {
        bottom: "-32px",
    },
    "& .swiper-pagination .swiper-pagination-bullet-active": {
        backgroundColor: "var(--community-color-snow-white)",
    },
});

export const ArrowIconButton = styled(IconButton)({
    backgroundColor: "rgba(255,255,255,0.9)",
    borderRadius: "20px",
    width: "40px",
    height: "40px",
    ...BOX_SHADOWS.ELEVATION_3,
    "&:hover": {
        backgroundColor: "var(--community-color-snow-white)",
    },
    svg: {
        width: "16px",
        height: "16px",
    },
});

export const SwiperContainer = styled(Box)({
    overflow: "visible",
    margin: "0px",
    paddingBottom: "38px",
});

export const PreviewBox = styled(Box)({
    maxHeight: "80vh",
    display: "flex",
    borderRadius: "12px",
    position: "relative",
    backgroundColor: "var(--community-color-snow-white)",
    img: {
        objectFit: "cover",
        aspectRatio: "1/1",
        width: "100%",
        height: "auto",
        borderRadius: "12px",
    },
});

export const PreviewOverlayBox = styled(Box)({
    position: "absolute",
    backgroundColor: "var(--community-color-transparent-black-50)",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    borderRadius: "12px",
});

export const PreviewOverlayIconButton = styled(IconButton)({
    width: "40px",
    height: "40px",
    border: "1px solid #FFF",
});
